<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex lg12>
        <v-card>
          <hpo-filter
            :headers="headers"
            :viewName="viewName"
            v-on:applyFilter="applyFilter"
            v-on:quickFilter="quickFilter"
          ></hpo-filter>
          <v-data-table
            :headers="headers"
            :items="items"
            :options.sync="pagination"
            :server-items-length="total_rows"
            :footer-props="items_per_page"
            :must-sort="true"
            show-select
            :mobile-breakpoint="100"
            v-model="selectedTranCodes"
            item-key="ID"
          >
          <template v-slot:item="{ item, isSelected, select}">
              <tr :id="'r-'+item.ID" :active="isSelected">
                <td v-if="item.Over30Days" @click="select(!isSelected)"><v-checkbox primary hide-details :input-value="isSelected"></v-checkbox></td>
                <td v-else></td>
                <td class="text-center">
                  <v-img :src="item.ProductImage" width="64px" height="64px" @click="showImage(item)"></v-img>
                </td>
                <td>{{ item.TransactionCode }}</td>
                <td>
                    <v-edit-dialog :return-value.sync="item.ProductType" large lazy persistent @save="saveItem({'ID': item.ID, 'ProductType': item.ProductType})">
                        <div :class="'product-type-' + item.ProductType">{{ item.ProductType | display_value(product_types, 'ID', 'Name') }}</div>
                        <template v-slot:input>
                        <v-autocomplete
                            :items="product_types"
                            v-model="item.ProductType"
                            item-text="Name"
                            item-value="ID"
                        ></v-autocomplete>
                        </template>
                    </v-edit-dialog>
                </td>
                <td class="text-end">{{ item.NumberOfPack | currency }}</td>
                <td class="text-end">{{ item.Weight | currency('', 2) }}</td>
                <td>{{ item.StoreVNImportDate | display_date }}</td>
                <td>
                  <v-edit-dialog :return-value.sync="item.StoreVNNote" large lazy persistent @save="saveItem({'ID': item.ID, 'StoreVNNote': item.StoreVNNote})">
                      <div>{{ item.StoreVNNote }}</div>
                      <template v-slot:input>
                          <v-text-field v-model="item.StoreVNNote"></v-text-field>
                      </template>
                  </v-edit-dialog>
                </td>
                <td class="text-center">
                  <v-tooltip>
                      <template v-slot:activator="{ on }">
                          <input type="file" ref="fileInput" style="display: none" @change="previewImage" accept="image/*" > 
                          <v-icon v-on="on" medium @click="chooseImage(item)">fa-upload</v-icon>
                      </template>
                      <span>Up ảnh</span>
                  </v-tooltip>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
    <image-viewer :activated="dialogViewer" :image_url="currentTransaction.ProductImage" @update:activated="dialogViewer = false"></image-viewer>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import configs from "../../configs";
import Filtering from "@/components/Filtering";
import firebase from 'firebase';
import { sendErrorNotice, makeid } from "@/commons/utils";
import image_viewer from "@/components/popups/image_viewer";
import _ from "lodash";

export default {
  components: {
    "hpo-filter": Filtering,
    'image-viewer': image_viewer
  },
  data() {
    let dataType = configs.DATA_TYPE;
    return {
      selected: [],
      selectedTranCodes: [],
      selectedCustomerID: 0,
      dialogCreateDeposit: false,
      imageData: null,
      currentTransaction: {},
      hideImage: false,
      dialogViewer: false,
      headers: [
        {
          text: "Hình ảnh",
          value: "",
          align: "center",
          sortable: false,
          filterable: false,
          width: 64
        },
        {
          text: "Mã vận đơn",
          value: "TransactionCode",
          filterable: true,
          quickSearch: true,
          dataType: dataType["String"]
        },
        {
            text: "Loại hàng",
            value: "ProductType",
            filterable: true,
            dataType: configs.DATA_TYPE["Enum"],
            values: []
        },
        {
          text: "Số kiện",
          value: "NumberOfPack",
          filterable: true,
          quickSearch: false,
          align: "end",
          dataType: dataType["Number"]
        },
        {
          text: "Cân nặng",
          value: "Weight",
          filterable: true,
          quickSearch: false,
          align: "end",
          dataType: dataType["Number"]
        },
        {
          text: "Nhập kho VN",
          value: "StoreVNImportDate",
          filterable: true,
          dataType: dataType["Date"]
        },
        {
          text: "Ghi chú",
          value: "StoreVNNote",
          filterable: true,
          quickSearch: true,
          dataType: dataType["String"]
        },
        {
          text: "Thao tác",
          value: "",
          align: "center",
          sortable: false,
          filterable: false
        }
      ],
      pagination: { ...configs.PAGINATION, sortBy: ["ID"]},
      items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
      viewName: "storemanager_list",
      filterConditions: [],
      quickFilterConditions: [],
      requireRules: [v => !!v || "Trường dữ liệu không được để trống."],
      dialogStoreManager: false,
      dialogEditTranCode: false
    };
  },
  watch: {
    pagination: {
      handler: function(val, oldVal) {
        let filterConditions = this.$store.state.commons.filterConditions;
        this.filterConditions = !_.isEmpty(filterConditions)
          ? filterConditions[this.viewName]
          : [];
        this.filter_data();
      },
      deep: true
    },
    product_types() {
        let header_item = _.find(this.headers, { value: "ProductType" });
        if (header_item) {
            header_item.values = _.map(this.product_types, (item) => {
                return {
                    value: item.ID,
                    name: item.Name
                }
            }) || []
        }
    }
  },
  computed: {
    ...mapState({
      items: state => state.orderTransaction.all.data,
      total_rows: state => state.orderTransaction.all.total,
      currentItem: state => state.orderTransaction.selected,
      loading: state => state.orderTransaction.loading,
      packages: state => state.bigPackage.inTQ,
      guarantees: state => {
        let tmp = [{name: 'Không sử dụng', value: 0}];
        if(state.feeGuarantee.all.data) {
        state.feeGuarantee.all.data.forEach(element => {
            tmp.push({name: element.PackageName, value: element.ID});
        });
        }
        return tmp;
      },
      customers: state => state.customer.master.data,
      product_types: state => state.productType.all.data,
    }),
    param() {
      let pr = {
        pagination: this.pagination,
        filter: this.filterConditions,
        quickFilter: this.quickFilterConditions
      };
      pr.filter.push({
        column: "UID",
        value: 0,
        condition: "equal"
      });
      pr.filter.push({
        column: "Status",
        value: 4,
        condition: "equal"
      });
      return pr;
    }
  },
  methods: {
    filter_data: function() {
      this.selectedTranCodes = [];
      this.$store.dispatch("orderTransaction/getList", this.param);
    },
    gotoDetail: function(id) {
      let item = _.find(this.items, { ID: id });
      this.$store.commit("orderTransaction/setDetail", { data: item });
      this.dialogEditTranCode = true;
    },
    deleteItem: function(id) {
      window.getApp.$emit("REQUEST_DELETE_DATA", id);
    },    
    applyFilter(filterConditions) {
      let sortBy = this.pagination.sortBy;
      let sortDesc = this.pagination.sortDesc;
      this.pagination = configs.PAGINATION;
      this.pagination.sortBy = sortBy;
      this.pagination.sortDesc = sortDesc;
      this.filterConditions = filterConditions;
      this.filter_data();
    },
    quickFilter(filterConditions) {
      this.quickFilterConditions = filterConditions;
      this.filter_data();
    },
    createData(username = "") {
      if(this.storeRole & 2) {
        this.$store.commit("orderTransaction/setDetail", {
          data: {
            ID: 0,
            TransactionCode: "",
            FeeShip: 0
          }
        });
        this.dialogStoreManager = true;
      }
      else {
        sendErrorNotice("Bạn không có quyền thêm mới!");
      }
    },
    saveItem(item) {
      this.$store.dispatch("orderTransaction/setDetail", {
        data: {
          ...item,
          'TransactionView': 'store_tq'
        },
        id: item.ID,
        param: this.param
      });
    },
    closePopup() {
      this.dialogStoreManager = false;
      this.filter_data();
    },
    getBigPackage(bigPackageID) {
      const item = _.find(this.packages, {ID: bigPackageID});
      return item ? item.PackageCode : '';
    },
    createDepositOrder() {
      this.dialogCreateDeposit = true;
      this.selectedCustomerID = 0;
    },
    onCreateDepositOrder() {
      let newOrder = {Status: 16};
      let rightSeleted = _.filter(this.selected, (p) => {return !p.OrderID;});
      if(rightSeleted.length == 0) {
          sendErrorNotice("Hãy chọn danh sách mã vận đơn vô chủ!");
          return;
      }
      if(this.selectedCustomerID == 0) {
          sendErrorNotice("Hãy chọn khách hàng!");
          return;
      }
      const cust = _.find(this.customers, {'ID': this.selectedCustomerID});
      newOrder.UID = this.selectedCustomerID;
      newOrder.Username = cust.Username;
      newOrder.ReceivePlaceID = cust.ReceivePlaceID;
      newOrder.ChinaStoreID = cust.ChinaStoreID;
      newOrder.CustomerServiceID = cust.CustomerServiceID;
      newOrder.TransactionIDs = _.map(rightSeleted, "ID")

      this.$store.dispatch("deposit/setDetail", {'data': newOrder});
      this.selected = []
      this.dialogCreateDeposit = false;
    },
    getCustomerText(item) {
      return `DL${item.ID} - ${item.Username}`
    },
    chooseImage(item) {
      this.currentTransaction = item;
      this.currentTransaction.ProductImage = '';
      this.$refs.fileInput.click();
    },
    previewImage(event) {
      this.imageData = event.target.files[0];
      this.$refs.fileInput.value = null;
      this.onUpload()
    },
    onUpload() {
      const arrFileType = this.imageData.name.split('.');
      const storageRef=firebase.storage().ref(`${configs.SYSTEM_CONFIG.firebase_prefix}/${makeid(30)}.${arrFileType[arrFileType.length - 1]}`).put(this.imageData);
      storageRef.on(`state_changed`, snapshot => {
              
          },
          error => {
              sendErrorNotice('File ảnh chỉ được tối đa 1Mb!');
          },
          () => {
              storageRef.snapshot.ref.getDownloadURL().then((url) => {
                  this.currentTransaction.ProductImage =url;
                  this.hideImage = true;
                  this.$nextTick(() => this.hideImage = false);
                  this.$store.dispatch("orderTransaction/setDetail", {
                    data: {
                      ProductImage: this.currentTransaction.ProductImage
                    },
                    id: this.currentTransaction.ID
                  });
              });
          }
      );
    },
    showImage(item) {
      this.currentTransaction = item;
      this.dialogViewer = true;
    },
    deleteData() {
      window.getApp.$emit("REQUEST_CONFIRM_ACTION", 'DeleteItems', 0, `Bạn có chắc chắn nhận xóa các kiện hàng không?`);
    }
  },
  mounted() {
    this.$store.dispatch("productType/getList");
    this.$store.dispatch("customer/getCustomerList", {
      is_master: 1,
      fields: ["ID", "Username", "ReceivePlaceID", "ChinaStoreID"]
    });
    this.$root.$emit('REQUEST_ROOT_OPTION', {});
    this.$root.$on("REQUEST_CREATE_DATA", this.createData);
    this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
    this.$root.$on("REQUEST_SAVE_DATA", this.createDepositOrder);
    this.$root.$on("REQUEST_OTHER_ACTION", this.deleteData);
    this.$root.$on("CONFIRMED_REMOVE_DATA", id => {
      this.$store.dispatch("orderTransaction/setDetail", {
        data: {
          'RequestAction': 'DEL',
          'TransactionView': 'store_cn'
        },
        'id': id,
        param: this.param
      });
    });
    this.$root.$on("CONFIRMED_ACTION", ({action, id}) => {
      if(action == 'DeleteItems') {
        let transaction_ids = _.map(this.selectedTranCodes, "ID");
        let payload = {
          TransactionIDs: transaction_ids,
          Action: "Delete"
        };
        if(transaction_ids.length == 0) {
          sendErrorNotice("Hãy chọn danh sách mã vận đơn muốn xóa.");
        }
        if(transaction_ids.length > 0) {
          this.$store.dispatch("orderTransaction/updateMultiple", payload);
        }
      }
    });
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_CREATE_DATA");
    this.$root.$off("REQUEST_REFRESH_DATA");
    this.$root.$off("REQUEST_SAVE_DATA");
    this.$root.$off("CONFIRMED_REMOVE_DATA");
    this.$root.$off("REQUEST_OTHER_ACTION");
    this.$root.$off("CONFIRMED_ACTION");
  }
};
</script>